import { WrestlerDetailViewData } from '../../screens/roster/RosterScreen'
import React, { ReactElement } from 'react'
import styles from './WebWrestlerDetailView.module.scss'
import { DesktopBodyLarge, DesktopHeadlineLarge } from '../../Typography'
import { URLS } from '../../content/urls'

type Props = {
  data: WrestlerDetailViewData
}

export const WebWrestlerDetailView = ({ data }: Props): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.imageColumn}>
        <div className={styles.textBox} onClick={data.onBackClick}>
          <DesktopBodyLarge>Zurück zum Roster</DesktopBodyLarge>
        </div>
        <div className={styles.imageWrapper}>
          <img
            src={
              data.wrestler.profilbild !== '' ? data.wrestler.profilbild : URLS.vakantWrestlerImage
            }
            alt={`Foto von ${data.wrestler.name}`}
          />
        </div>
      </div>
      <div className={styles.infoColumn}>
        <div className={styles.wrestlerDetailColumn}>
          <DesktopHeadlineLarge>{data.wrestler.name}</DesktopHeadlineLarge>
          <div className={styles.metaDataColumn}>
            <div className={styles.metaDataRow}>
              <DesktopBodyLarge fontWeight={700}>Herkunft</DesktopBodyLarge>
              <DesktopBodyLarge>{data.wrestler.herkunft}</DesktopBodyLarge>
            </div>
            <div className={styles.metaDataRow}>
              <DesktopBodyLarge fontWeight={700}>Größe</DesktopBodyLarge>
              <DesktopBodyLarge>{data.wrestler.groesse}</DesktopBodyLarge>
            </div>
            <div className={styles.metaDataRow}>
              <DesktopBodyLarge fontWeight={700}>Gewicht</DesktopBodyLarge>
              <DesktopBodyLarge>{data.wrestler.gewicht}</DesktopBodyLarge>
            </div>
            <div className={styles.metaDataRow}>
              <DesktopBodyLarge fontWeight={700}>Finisher</DesktopBodyLarge>
              <div className={styles.movesList}>
                {data.wrestler.finisher.map((finisher, index) => (
                  <DesktopBodyLarge key={index}>{finisher}</DesktopBodyLarge>
                ))}
              </div>
            </div>
            <div className={styles.metaDataRow}>
              <DesktopBodyLarge fontWeight={700}>Signature</DesktopBodyLarge>
              <div className={styles.movesList}>
                {data.wrestler.signature.map((signature, index) => (
                  <DesktopBodyLarge key={index}>{signature}</DesktopBodyLarge>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.biography}>
            <DesktopBodyLarge dangerouslySetInnerHTML={{ __html: data.wrestler.biografie }} />
          </div>
        </div>
      </div>
    </div>
  )
}
